// Landing Page Design Templates for Public Quote View
// Each template defines the full color scheme, fonts, and visual style

export const LANDING_PAGE_TEMPLATES = [
  {
    id: 'modern',
    name: 'Modern',
    description: 'Sauber, hell, professionell – ideal für digitale Agenturen',
    font: "'Inter', system-ui, sans-serif",
    borderRadius: '12px',
    preview: { bg: '#f1f5f9', header: '#ffffff', accent: '#3b82f6', text: '#1e293b' },
    colors: {
      primaryColor: '#3b82f6', secondaryColor: '#6366f1', accentColor: '#f59e0b',
      landingPageBgColor: '#f1f5f9', colorEinmalig: '#22c55e', colorMonatlich: '#f97316', colorJaehrlich: '#a855f7'
    }
  },
  {
    id: 'corporate',
    name: 'Corporate',
    description: 'Seriös, vertrauenswürdig – für Beratung & Finanzen',
    font: "'Georgia', 'Times New Roman', serif",
    borderRadius: '4px',
    preview: { bg: '#f8fafc', header: '#0f172a', accent: '#b45309', text: '#0f172a' },
    colors: {
      primaryColor: '#1e3a5f', secondaryColor: '#b45309', accentColor: '#d97706',
      landingPageBgColor: '#f8fafc', colorEinmalig: '#0d9488', colorMonatlich: '#b45309', colorJaehrlich: '#7c3aed'
    }
  },
  {
    id: 'dark',
    name: 'Dark',
    description: 'Modern dunkel, hochwertig – für Tech & Software',
    font: "'Space Grotesk', system-ui, sans-serif",
    borderRadius: '16px',
    preview: { bg: '#0f172a', header: '#1e293b', accent: '#22d3ee', text: '#f1f5f9' },
    colors: {
      primaryColor: '#22d3ee', secondaryColor: '#818cf8', accentColor: '#f472b6',
      landingPageBgColor: '#0f172a', colorEinmalig: '#34d399', colorMonatlich: '#fb923c', colorJaehrlich: '#c084fc'
    }
  },
  {
    id: 'warm',
    name: 'Warm',
    description: 'Einladend, persönlich – für Handwerk & Gastronomie',
    font: "'Merriweather', Georgia, serif",
    borderRadius: '8px',
    preview: { bg: '#fffbf5', header: '#fff7ed', accent: '#d97706', text: '#451a03' },
    colors: {
      primaryColor: '#d97706', secondaryColor: '#dc2626', accentColor: '#16a34a',
      landingPageBgColor: '#fffbf5', colorEinmalig: '#16a34a', colorMonatlich: '#d97706', colorJaehrlich: '#9333ea'
    }
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Reines Weiß, keine Ablenkung – für Coaches & Berater',
    font: "'DM Sans', system-ui, sans-serif",
    borderRadius: '0px',
    preview: { bg: '#ffffff', header: '#ffffff', accent: '#18181b', text: '#18181b' },
    colors: {
      primaryColor: '#18181b', secondaryColor: '#52525b', accentColor: '#3b82f6',
      landingPageBgColor: '#ffffff', colorEinmalig: '#16a34a', colorMonatlich: '#d97706', colorJaehrlich: '#7c3aed'
    }
  },
  {
    id: 'bold',
    name: 'Bold',
    description: 'Kräftig, auffällig – für Kreativagenturen & Marketing',
    font: "'Poppins', system-ui, sans-serif",
    borderRadius: '20px',
    preview: { bg: '#fdf4ff', header: '#7e22ce', accent: '#ec4899', text: '#1a1a2e' },
    colors: {
      primaryColor: '#7e22ce', secondaryColor: '#ec4899', accentColor: '#f97316',
      landingPageBgColor: '#fdf4ff', colorEinmalig: '#16a34a', colorMonatlich: '#ec4899', colorJaehrlich: '#7e22ce'
    }
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Print-Stil, zeitlos – für traditionelle Unternehmen',
    font: "'Playfair Display', Georgia, serif",
    borderRadius: '0px',
    preview: { bg: '#fafaf8', header: '#1a1a1a', accent: '#8b7355', text: '#1a1a1a' },
    colors: {
      primaryColor: '#1a1a1a', secondaryColor: '#8b7355', accentColor: '#c41e3a',
      landingPageBgColor: '#fafaf8', colorEinmalig: '#2d5016', colorMonatlich: '#8b4513', colorJaehrlich: '#4b0082'
    }
  },
  {
    id: 'startup',
    name: 'Startup',
    description: 'Modern eckig, energetisch – für Tech-Startups',
    font: "'Space Grotesk', system-ui, sans-serif",
    borderRadius: '0px',
    preview: { bg: '#f0fdf4', header: '#052e16', accent: '#00dc82', text: '#052e16' },
    colors: {
      primaryColor: '#059669', secondaryColor: '#0ea5e9', accentColor: '#f59e0b',
      landingPageBgColor: '#f0fdf4', colorEinmalig: '#059669', colorMonatlich: '#0ea5e9', colorJaehrlich: '#7c3aed'
    }
  },
];

export const getTemplateById = (id) =>
  LANDING_PAGE_TEMPLATES.find(t => t.id === id) || LANDING_PAGE_TEMPLATES[0];

// ─────────────────────────────────────────────────────────────────────────────
// LAYOUT-ARCHETYPEN — strukturell verschiedene Angebotsseiten.
// Anders als die Farb-Skins oben verändern diese das GRUNDGERÜST (Hero, Service-
// Darstellung, CTA). Die CI (Farben + Schrift) kommt immer aus den Firmen-
// Einstellungen und überschreibt die Defaults hier.
// ─────────────────────────────────────────────────────────────────────────────
// mode 'brand'     → CI (Firmenfarben) dominieren das ganze Theme.
// mode 'signature' → der Stil-Look bleibt fix; nur Markenfarbe (Akzent) + Schrift
//                    sind editierbar. Volle Palette steht in `palette`.
export const QUOTE_LAYOUTS = [
  {
    id: 'document', name: 'Dokument', mode: 'brand',
    description: 'Seriös, formell – wie eine hochwertige Rechnung. Vertrauen pur.',
    dark: false, font: "'Inter', system-ui, sans-serif", borderRadius: '12px',
    defaults: { primary: '#3b82f6', accent: '#f59e0b', bg: '#f1f5f9' },
  },
  {
    id: 'pitch', name: 'Pitch', mode: 'brand',
    description: 'Verkäuferisch – personalisierte Headline, Nutzen-Karten, klarer CTA.',
    dark: false, font: "'Poppins', system-ui, sans-serif", borderRadius: '18px',
    defaults: { primary: '#d97706', accent: '#ef4444', bg: '#fffbf5' },
  },
  {
    id: 'premium', name: 'Premium', mode: 'brand',
    description: 'Dunkel, Serif, viel Weißraum – hochpreisig & edel. Preis als Statement.',
    dark: true, font: "'Playfair Display', Georgia, serif", borderRadius: '16px',
    defaults: { primary: '#22d3ee', accent: '#f472b6', bg: '#0f172a' },
  },
  {
    id: 'onepager', name: 'Onepager', mode: 'brand',
    description: 'Moderne SaaS-Landingpage – Value-Props + Pricing-Cards nebeneinander.',
    dark: false, font: "'Space Grotesk', system-ui, sans-serif", borderRadius: '14px',
    defaults: { primary: '#2563eb', accent: '#059669', bg: '#eff6ff' },
  },

  // ── Signature-Stile (Look fix, nur Markenfarbe + Schrift editierbar) ────────
  {
    id: 'apple', name: 'Apple', mode: 'signature',
    description: 'Riesige Typo, maximaler Weißraum, zentriert, Pill-CTA. Reduziert & edel.',
    font: "-apple-system, 'SF Pro Display', 'Helvetica Neue', sans-serif", borderRadius: '18px',
    defaults: { primary: '#0071e3' },
    palette: { dark: false, bg: '#ffffff', surface: '#ffffff', surfaceBorder: '#d2d2d7', textPrimary: '#1d1d1f', textSecondary: '#86868b', textMuted: '#a1a1a6', typeColor: '#1d1d1f' },
  },
  {
    id: 'notion', name: 'Notion', mode: 'signature',
    description: 'Warmes Off-White, Doc-Stil, Callout-Blöcke, Monospace-Metadaten. Nahbar.',
    font: "ui-sans-serif, -apple-system, 'Segoe UI', sans-serif", borderRadius: '4px',
    defaults: { primary: '#2383e2' },
    palette: { dark: false, bg: '#ffffff', surface: '#fbfbfa', surfaceBorder: '#e9e9e7', textPrimary: '#37352f', textSecondary: '#787774', textMuted: '#9b9a97', typeColor: '#37352f' },
  },
  {
    id: 'linear', name: 'Linear', mode: 'signature',
    description: 'Fast schwarz, Lila-Glow, Mono-Labels, gestochen scharf. Tech-Premium.',
    font: "'Inter', system-ui, sans-serif", borderRadius: '8px',
    defaults: { primary: '#7c6cf6' },
    palette: { dark: true, bg: '#08090a', surface: '#101113', surfaceBorder: '#23252a', textPrimary: '#f7f8f8', textSecondary: '#8a8f98', textMuted: '#62666d', typeColor: '#7c6cf6' },
  },
  {
    id: 'stripe', name: 'Stripe', mode: 'signature',
    description: 'Multicolor-Verlauf-Header, schwebende Karten, Indigo. Developer-Premium.',
    font: "-apple-system, 'Helvetica Neue', sans-serif", borderRadius: '10px',
    defaults: { primary: '#635bff' },
    palette: { dark: false, bg: '#f6f9fc', surface: '#ffffff', surfaceBorder: '#e6ebf1', textPrimary: '#32325d', textSecondary: '#6b7c93', textMuted: '#8898aa', typeColor: '#635bff' },
  },
  {
    id: 'swiss', name: 'Swiss / Editorial', mode: 'signature',
    description: 'Strenges Raster, fette Helvetica, roter Akzent, durchnummeriert. Magazin-Stil.',
    font: "'Helvetica Neue', Arial, sans-serif", borderRadius: '0px',
    defaults: { primary: '#e10600' },
    palette: { dark: false, bg: '#ffffff', surface: '#ffffff', surfaceBorder: '#111111', textPrimary: '#111111', textSecondary: '#444444', textMuted: '#777777', typeColor: '#111111' },
  },
  {
    id: 'brutalist', name: 'Brutalist', mode: 'signature',
    description: 'Rohe schwarze Rahmen, Monospace, Knall-Akzent, [x]-Listen. Maximal mutig.',
    font: "ui-monospace, 'Courier New', monospace", borderRadius: '0px',
    defaults: { primary: '#1a1a1a', accent: '#ffe14d' },
    palette: { dark: false, bg: '#f4f1ea', surface: '#ffffff', surfaceBorder: '#1a1a1a', textPrimary: '#1a1a1a', textSecondary: '#444444', textMuted: '#6b6b6b', typeColor: '#1a1a1a' },
  },
];

export const getLayoutById = (id) =>
  QUOTE_LAYOUTS.find(l => l.id === id) || QUOTE_LAYOUTS[0];

// Map alter Farb-Skin-IDs ('modern','dark',...) auf einen Layout-Archetyp,
// damit bestehende Firmen-Einstellungen weiter funktionieren.
const LEGACY_SKIN_TO_LAYOUT = {
  modern: 'document', corporate: 'document', minimal: 'document', classic: 'document',
  warm: 'pitch', bold: 'pitch',
  dark: 'premium',
  startup: 'onepager',
};

// Welcher Layout-Archetyp ist für diese Firma aktiv?
export const getLayoutId = (company) => {
  const raw = company?.landingPageLayout || company?.landingPageTemplate || 'document';
  if (QUOTE_LAYOUTS.some(l => l.id === raw)) return raw;
  return LEGACY_SKIN_TO_LAYOUT[raw] || 'document';
};

// Baut das Theme.
// - brand-Modus:     CI dominiert (Firmenfarben überschreiben Defaults).
// - signature-Modus: Stil-Palette ist fix; nur Markenfarbe (primary/accent) +
//                    Schrift kommen aus der CI. Die Typ-Farben bleiben bewusst
//                    dezent (Stil-typeColor), damit der Look nicht zerbricht.
export const buildTheme = (company = {}) => {
  const layout = getLayoutById(getLayoutId(company));
  const d = layout.defaults || {};

  if (layout.mode === 'signature') {
    const p = layout.palette;
    // CI-Akzent-Schalter: standardmäßig greift die Markenfarbe als Akzent.
    // signatureBrandAccent === false → originaler Stil-Akzent (z.B. Swiss = Rot).
    const useBrandAccent = company?.signatureBrandAccent !== false;
    const brand = useBrandAccent ? (company?.primaryColor || d.primary) : d.primary;
    return {
      layoutId: layout.id, mode: 'signature', dark: p.dark,
      font: company?.landingPageFont || layout.font,
      radius: layout.borderRadius,
      bg: p.bg, surface: p.surface, surfaceBorder: p.surfaceBorder,
      textPrimary: p.textPrimary, textSecondary: p.textSecondary, textMuted: p.textMuted,
      primary: brand,
      accent: d.accent || brand,
      // Typ-Farben dezent halten – Markenfarbe greift nur an Akzenten.
      einmalig: p.typeColor, monatlich: p.typeColor, jaehrlich: p.typeColor,
    };
  }

  return {
    layoutId: layout.id, mode: 'brand', dark: layout.dark,
    font: company?.landingPageFont || layout.font,
    radius: layout.borderRadius,
    bg: company?.landingPageBgColor || d.bg,
    primary: company?.primaryColor || d.primary,
    accent: company?.accentColor || d.accent,
    einmalig: company?.colorEinmalig || '#22c55e',
    monatlich: company?.colorMonatlich || '#f97316',
    jaehrlich: company?.colorJaehrlich || '#a855f7',
    surface: layout.dark ? '#1e293b' : '#ffffff',
    surfaceBorder: layout.dark ? '#334155' : '#e2e8f0',
    textPrimary: layout.dark ? '#f1f5f9' : '#0f172a',
    textSecondary: layout.dark ? '#94a3b8' : '#64748b',
    textMuted: layout.dark ? '#64748b' : '#94a3b8',
  };
};
